import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface DemoState {
  name: string;
  dummyText: string;
}

const initialState: DemoState = {
  name: "React Typescript Boilerplate",
  dummyText: "as",
};

const demoSlice = createSlice({
  name: "demo",
  initialState,
  reducers: {
    setName: (state, action: PayloadAction<{ name: string }>) => {
      state.name = action.payload.name;
    },
    setDummyText: (state, action: PayloadAction<{ dummyText: string }>) => {
      state.dummyText = action.payload.dummyText;
    },
  },
});

export const { setName, setDummyText } = demoSlice.actions;

export default demoSlice.reducer;
